import styled, { css, keyframes, createGlobalStyle } from 'styled-components';
import { FONT_PROPERTIES } from 'common/components/TouchpointEditor/components/TouchpointContainer';

import { EDITOR_SIDEBAR_WIDTH, WORKSPACE_TOPBAR_HEIGHT } from 'common/styles/variables';
import { mediaMaxWidth } from 'common/styles/breakpoints';

const appearAnimation = keyframes`
0% {
    opacity: 0;
}
100% {
    opacity: 1;
}
`;

const slideUp = keyframes`
0% {
    transform: translateY(2rem);
}
100% {
    transform: translateY(0);
}
`;

export const SpeakerModalContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 100vh;
    overflow: auto;
    padding: 4rem;
    animation: ${appearAnimation} linear 250ms forwards;
    background-color: rgba(0, 0, 0, 0.5); // eslint-disable-line splash/sui-colors-only

    ${mediaMaxWidth.medium`
        padding: 3rem 1rem;
    `};

    z-index: 1;
`;

export const SpeakerModalWrapper = styled.div`
    max-width: 650px;
    margin: 0 auto;
    background-color: ${(props) => props.$backgroundColor};
    padding: 3.5rem 4.75rem;
    position: relative;

    animation: ${slideUp} linear 250ms forwards;

    ${mediaMaxWidth.medium`
        padding: 1.5rem;
    `};
`;

export const CloseButtonContainer = styled.button`
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
    border: none;
    padding: 2rem;
    color: ${(props) => props.$color};
    cursor: pointer;
    transition: color 100ms ease;
    background-color: transparent;
    outline-style: none;

    &:hover {
        color: ${(props) => props.$colorHover};
    }

    &:focus {
        outline-style: auto;
    }
`;

export const SpeakerImage = styled.img`
    width: 100px;
    height: 100px;
    border-radius: 50%;
    object-fit: cover;
    overflow: hidden;
`;

export const SpeakerName = styled.h2`
    line-height: 1.5;
    padding-top: 2.5rem;

    ${FONT_PROPERTIES}
`;

export const SpeakerTitleAndCompany = styled.h3`
    line-height: 1.5;
    padding-top: 0.75rem;

    ${FONT_PROPERTIES}
`;

export const SpeakerBio = styled.p`
    line-height: 1.5;
    padding-top: 3rem;

    ${FONT_PROPERTIES}
`;

const editorCss = css`
    top: ${WORKSPACE_TOPBAR_HEIGHT};
    width: calc(100% - ${EDITOR_SIDEBAR_WIDTH});
`;

export const SpeakerModalGlobalStyles = createGlobalStyle`
    .SessionSpeakerModal {
        ${(props) => (props.isEditing ? editorCss : '')}
    }
`;
